import { z } from 'zod';
import superjson from 'superjson';
import { CheckpointType } from '../../helpers/schema';

export const schema = z.object({
  sessionId: z.string().min(1),
});

export type InputType = z.infer<typeof schema>;

export type CheckpointListItem = {
  id: string;
  name: string;
  description: string | null;
  checkpointType: CheckpointType;
  createdAt: Date | string | null;
  sessionId: string;
  filesSnapshot: unknown;
  createdBy: {
    id: number;
    displayName: string | null;
    avatarUrl: string | null;
  } | null;
};

export type OutputType = {
  checkpoints: CheckpointListItem[];
};

export const getCheckpointsList = async (
  input: InputType,
  init?: RequestInit,
): Promise<OutputType> => {
  const params = new URLSearchParams({ sessionId: input.sessionId });
  const result = await fetch(`/_api/checkpoints/list?${params.toString()}`, {
    method: 'GET',
    credentials: 'include',
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers ?? {}),
    },
  });
  if (!result.ok) {
    const errorObject = superjson.parse<{ error: string }>(await result.text());
    throw new Error(errorObject.error);
  }
  return superjson.parse<OutputType>(await result.text());
};
